import React, { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { routeName } from "Service/env";
import { connect } from "react-redux";

function PaymentResult({ currentEventDetails }) {
    const [message, setMessage] = useState("Checking payment status...");
    const [retryCount, setRetryCount] = useState(0);

    useEffect(() => {
        const publicKey = localStorage.getItem("public_key");

        if (!publicKey) {
            redirectToEvent("Unable to load Stripe. Missing public key.");
            return;
        }

        const clientSecret = new URLSearchParams(window.location.search).get(
            "payment_intent_client_secret"
        );
        if (!clientSecret) {
            redirectToEvent("Unable to verify payment. Please try again.");
            return;
        }

        loadStripe(publicKey).then((stripe) => {
            if (!stripe) {
                redirectToEvent("Failed to initialize Stripe.");
                return;
            }

            stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
                if (!paymentIntent) {
                    redirectToEvent("Unable to verify payment.");
                    return;
                }

                switch (paymentIntent.status) {
                    case "succeeded":
                        // ✅ Success page
                        window.location.replace(`${routeName}/success`);
                        break;

                    case "processing":
                        setMessage(
                            "Your payment is processing. You will be redirected shortly…"
                        );
                        if (retryCount < 5) {
                            setRetryCount((prev) => prev + 1);
                            setTimeout(() => window.location.reload(), 1500);
                        }
                        break;

                    case "requires_payment_method":
                    case "canceled":
                    default:
                        // ❌ Failure or Klarna unsupported → redirect to event page with message
                        redirectToEvent(
                            "Payment failed or was canceled. Please choose another payment method."
                        );
                        break;
                }
            });
        });
    }, [retryCount, currentEventDetails]);

    const redirectToEvent = (msg) => {
        const eventId = currentEventDetails?.EventId;
        if (!eventId) return;

        // encode message as query param
        const url = `${routeName}/event/${eventId}?payment_message=${encodeURIComponent(msg)}`;

        // replace history so back button does not go to Klarna
        window.location.replace(url);
    };

    return (
        <div style={{ padding: "2rem", textAlign: "center" }}>
            <h3>{message}</h3>
        </div>
    );
}

const mapStateToProps = (state) => ({
    currentEventDetails: state.eventReducer.currentEventDetails,
});

export default connect(mapStateToProps)(PaymentResult);
